import {
  INTEGRATION_ACCOUNTS_LIST_REQUEST,
  INTEGRATION_ACCOUNTS_LIST_SUCCESS,
  INTEGRATION_ACCOUNTS_LIST_ERROR,
  INTEGRATION_ACCOUNTS_LIST_SET,
  DELETE_INTEGRATION_ACCOUNTS_REQ
} from './integration-accounts.type'

import ApiRest from '@/api/api-rest'
import IQCollection from '@/resources/collections/IQCollection'
import { alertAccountsMetaInfo } from '@/column-header/integration_accounts/alert-accounts.meta'
import { OrderByEnum } from '@/constants/orderby.constants'

const state = {
  alertIntegrationAccountsReqStatus: '',
  alertIntegrationAccounts: {},
  alertIntegrationSummary: {
    accountCount: 0,
    vmCount: 0,
    detectionsCount: 0,
    progressionCount: 0
  }
}

const getters = {
  alertIntegrationAccountsReqStatus: state => state.alertIntegrationAccountsReqStatus,
  alertIntegrationAccounts: state => state.alertIntegrationAccounts,
  alertIntegrationSummary: state => state.alertIntegrationSummary
}

// Best Practice - updates state
const mutations = {
  [INTEGRATION_ACCOUNTS_LIST_REQUEST]: state => (state.alertIntegrationAccountsReqStatus = 'loading'),
  [INTEGRATION_ACCOUNTS_LIST_SUCCESS]: state => (state.alertIntegrationAccountsReqStatus = 'saved'),
  [INTEGRATION_ACCOUNTS_LIST_ERROR]: state => (state.alertIntegrationAccountsReqStatus = 'error'),
  [INTEGRATION_ACCOUNTS_LIST_SET]: (state, data) => {
    state.alertIntegrationAccounts = data
    state.alertIntegrationSummary.accountCount = data.models.length
    state.alertIntegrationSummary.detectionsCount = _.sum(_.map(data.models, 'numAlertsGenerated'))
    state.alertIntegrationSummary.progressionCount = _.sum(_.map(data.models, 'numActiveThreatTrails'))
    state.alertIntegrationSummary.unhealthyCount = _.filter(data.models, { status: 'UNHEALTHY' }).length
  }
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [INTEGRATION_ACCOUNTS_LIST_REQUEST] (context, integration) {
    context.commit(INTEGRATION_ACCOUNTS_LIST_REQUEST)
    return new Promise((resolve, reject) => {
      ApiRest()
        .get(`/integrations/accounts/alert`)
        .then(({ data }) => {
          let integrationAccounts = context.rootState.integrations.integrationList
          // merge discovery account with integrationList for health status and scan freq
          data = _.map(data, account => {
            let foundAcct = integrationAccounts[account.accountKey]
            if (foundAcct) {
              account = _.merge(account, foundAcct)
              if (account.config) {
                account.nickName = account.config.nickName
              } else {
                account.nickName = account.accountKey
              }
              if (!account.enabled) {
                account.status = 'DISABLED'
              }
              if (account.enabled && !account.status) {
                account.status = 'INITIALIZING'
              }
              if (!account.lastDetectionTime) {
                account.lastDetectionTime = 'NA'
              }
              account.containerText = 'Containers'
            }
            return account
          })
          data = new IQCollection(
            data,
            { attributes: alertAccountsMetaInfo.meta.columns },
            { defaultSort: 'nickName', sortOrder: OrderByEnum.DESC }
          )

          context.commit(INTEGRATION_ACCOUNTS_LIST_SET, data)
          context.commit(INTEGRATION_ACCOUNTS_LIST_SUCCESS)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(INTEGRATION_ACCOUNTS_LIST_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [DELETE_INTEGRATION_ACCOUNTS_REQ] (context, integrationId) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .delete(`/integrations/accounts/alert/${integrationId}`)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/integration_accounts/alertintegration-accounts.module.js